'use strict';

angular.module('docketbook').
  controller('selectActivityController', function(docketService, $rootScope, $window, $scope, $state, $stateParams, Restangular, accessControl, $timeout) {

    // Initialise variables to be used
    $scope.activitySearch = "";
    $scope.activitySearchLoading = false;
    $scope.activitySearchList = [];
    $scope.activitySearchListFull = [];
    $scope.activitySearchCallback = null;
    $scope.activityLoading = false;
    $scope.activityLoadingError = null;
    $scope.activityListLoadingCount = 0;
    $scope.listCount = 0;

    $scope.preventLoad = false;

    $scope.query = {
      limit: 10,
      page: 1,
      order: 'fileCode'
    };

    /***************************************/
    /***** Parent Controlled Functions *****/
    /***************************************/

    $scope.$parent.activitySelectFromParent = function(existing, cb) {
      $scope.activitySearch = "";
      $scope.activitySearchCurrent = "";
      $scope.activitySearchLoading = false;
      $scope.activityLoadingError = null;
      $scope.activitySearchList = [];
      $scope.activitySelectCallback = cb;
      $scope.existingFileCodes = existing;
      $scope.preventLoad = false;
      $scope.query.limit = 10;
      $scope.query.page = 1;
      $scope.loadActivityList(null);
    }

    $scope.loadActivityList = function(searchText) {
      var existing = $scope.existingFileCodes;
      $scope.activitySearchList = [];
      $scope.activitySearchCurrent = searchText;
      $scope.activitySearchLoading = true;
      $scope.getActivityList(searchText, function(fileCodes) {
        for ( var i = 0; i < fileCodes.length; i++ ) {
          var found = false;
          if ( existing ) {
            for ( var j = 0; j < existing.length; j++ ) {
              if ( existing[j].uniqueIdentifier == fileCodes[i].uniqueIdentifier ) {
                found = true;
                break;
              }
            }
          }

          if ( !found ) {
            $scope.activitySearchList.push(fileCodes[i]);
          }
        }
        $scope.activitySearchLoading = false;
      }, function(err) {
        $scope.activitySearchLoading = false;
        $scope.activityLoadingError = "Error loading file codes";
      });
    }

    $scope.selectActivity = function(activity) {
      $scope.activitySelectCallback(activity);
    }

    $scope.closeActivitySelectList = function() {
      $scope.activitySelectCallback(null);
    }

    /************************/
    /**** Load From API *****/
    /************************/

    $scope.getActivityList = function(searchText, successCb, failureCb) {
      var queryParams = {};
      queryParams.limit = $scope.query.limit;
      queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
      queryParams.sort = $scope.query.order;
      if ( searchText != null && searchText != "" ) {
        queryParams.search = searchText;
      }
      docketService.getFileCodes(queryParams, function(returnObject) {
        var fileCodeList = returnObject;
        if ( queryParams.offset <= 0 && returnObject.length < queryParams.limit ) {
          $scope.listCount = returnObject.length;
        } else {
          $scope.listCount = queryParams.offset + (queryParams.limit + 1);
        }
        successCb(fileCodeList);
      }, function(err) {
        failureCb(err);
      });
    }

    $scope.loadNextPageOfFileCodes = function(cb) {
      $scope.query.page += 1;
      $scope.getActivityList($scope.activitySearchCurrent, function(fileCodes) {
        if ( fileCodes.length == 0 ) {
          $scope.preventLoad = true;
          cb();
          return;
        }
        for ( var i = 0; i < fileCodes.length; i++ ) {
          $scope.activitySearchList.push(fileCodes[i]);
        }
        cb();
      }, function(err) {
        cb();
      });
    }

    $scope.loadingMoreItems = false;
    $scope.fileCodesLoadingCount = 0;
    angular.element($window).on('scroll', function() {
      if ( $(window).scrollTop() + $(window).height() > $(document).height() - 20 ) {
        var offset = $scope.query.limit * ($scope.query.page - 1);
        if ( !$scope.loadingMoreItems && !$scope.preventLoad ) {
          $scope.loadingMoreItems = true;
          $("#fileCodesLoadingMore").removeClass('hidden');
          $scope.loadNextPageOfFileCodes(function() {
            $scope.loadingMoreItems = false;
            $("#fileCodesLoadingMore").addClass("hidden");
          });
        }
      }
    });

    /********************************/
    /***** Search Functionality *****/
    /********************************/

    $scope.searchActivityChange = function(searchValue) {
      $scope.query.page = 1;
      $scope.loadActivityList(searchValue);
    }

    $scope.updateActivitySearch = function(searchValue) {
      $scope.query.page = 1;
      $scope.loadActivityList(searchValue);
    }

});



// WEBPACK FOOTER //
// ./src/controllers/selectors/selectActivityController.js